export default "__VITE_ASSET__7c49d38f__"